<template>
  <div class="home-box">

  </div>
</template>

<script>
import NavHeaderComponent from '../components/NavHeaderComponent'
export default {
  name: 'HomePage',
  components: { NavHeaderComponent },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="less">
.home-box {
  padding: 10px 0 0 10px;
  width:calc(100% - 10px);
}
</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue